import SEO from '../components/SEO';
import React from 'react';
import Navigation from '../components/Navigation';
import SiteFooter from '../components/SiteFooter';

export default function PrivacyPage() {
  return (
    <div className="flex flex-col min-h-screen bg-white">
      <SEO title="Privacy Policy" description="GetBenefitSavings privacy policy. How we protect your personal information and benefits data." path="/privacy" keywords="" />
      
      <Navigation />
      
      <section className="bg-gradient-hero py-20 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl md:text-6xl font-bold mb-6">Privacy Policy</h1>
          <p className="text-xl md:text-2xl opacity-90 max-w-2xl mx-auto">
            How we protect your information
          </p>
        </div>
      </section>

      <section className="py-16 bg-white flex-grow">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="prose prose-lg max-w-none">
            <p className="text-gray-600 mb-6">Last updated: February 15, 2026</p>
            
            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">Information We Collect</h2>
            <p className="text-gray-700 mb-4">
              We collect information you provide directly to us, including your name, email address, and any other information you choose to provide when using our services.
            </p>

            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">How We Use Your Information</h2>
            <p className="text-gray-700 mb-4">
              We use the information we collect to provide, maintain, and improve our services, send you newsletters and updates you've subscribed to, and respond to your comments and questions.
            </p>

            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">Data Security</h2>
            <p className="text-gray-700 mb-4">
              We take reasonable measures to help protect your personal information from loss, theft, misuse, unauthorized access, disclosure, alteration, and destruction.
            </p>

            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">Contact Us</h2>
            <p className="text-gray-700 mb-4">
              If you have any questions about this Privacy Policy, please contact us at privacy [at] getbenefitsavings [dot] com
            </p>
          </div>
        </div>
      </section>

      
      <SiteFooter />
    </div>
  );
}
